const accountingQuestions = [

{
  question: "The primary purpose of financial accounting is to:",
  options: ["provide financial information for decision making", "record only cash transactions", "calculate tax only", "audit accounts"],
  answer: "provide financial information for decision making"
},
{
  question: "Which of the following is NOT a user of accounting information?",
  options: ["competitors", "owners", "creditors", "government"],
  answer: "competitors"
},
{
  question: "The accounting equation is:",
  options: ["Assets = Capital + Liabilities", "Assets = Liabilities − Capital", "Capital = Assets + Liabilities", "Assets = Profit"],
  answer: "Assets = Capital + Liabilities"
},
{
  question: "If assets GH¢50,000 and liabilities GH¢20,000, capital is:",
  options: ["GH¢30,000", "GH¢50,000", "GH¢20,000", "GH¢70,000"],
  answer: "GH¢30,000"
},
{
  question: "A business purchases goods for cash GH¢5,000. Effect is:",
  options: ["asset decreases and asset increases", "liability increases", "capital increases", "no change"],
  answer: "asset decreases and asset increases"
},
{
  question: "Owner invests GH¢10,000 cash. Effect:",
  options: ["assets increase and capital increases", "assets decrease", "liabilities increase", "no change"],
  answer: "assets increase and capital increases"
},
{
  question: "Purchase on credit increases:",
  options: ["assets and liabilities", "assets only", "liabilities only", "capital"],
  answer: "assets and liabilities"
},
{
  question: "Which account is debited when cash is received?",
  options: ["cash account", "capital account", "sales account", "liability"],
  answer: "cash account"
},
{
  question: "Which account is credited when goods are sold?",
  options: ["sales account", "cash account", "expense account", "asset"],
  answer: "sales account"
},
{
  question: "Expenses are:",
  options: ["debited", "credited", "ignored", "transferred"],
  answer: "debited"
},
{
  question: "Revenue is:",
  options: ["credited", "debited", "ignored", "transferred"],
  answer: "credited"
},
{
  question: "If a business pays rent GH¢2,000, effect is:",
  options: ["cash decreases, expense increases", "cash increases", "liability increases", "capital increases"],
  answer: "cash decreases, expense increases"
},
{
  question: "If goods are sold for cash GH¢3,000, effect:",
  options: ["cash increases, revenue increases", "cash decreases", "liability increases", "expense increases"],
  answer: "cash increases, revenue increases"
},
{
  question: "If a debtor pays GH¢1,000, effect:",
  options: ["cash increases, debtor decreases", "cash decreases", "liability increases", "expense increases"],
  answer: "cash increases, debtor decreases"
},
{
  question: "Which account is credited when capital is introduced?",
  options: ["capital account", "cash account", "sales account", "expense"],
  answer: "capital account"
},
{
  question: "Assets are normally:",
  options: ["debited", "credited", "ignored", "closed"],
  answer: "debited"
},
{
  question: "Liabilities are normally:",
  options: ["credited", "debited", "ignored", "closed"],
  answer: "credited"
},
{
  question: "If assets increase by GH¢5,000 and liabilities remain same, capital:",
  options: ["increases by GH¢5,000", "decreases", "no change", "zero"],
  answer: "increases by GH¢5,000"
},
{
  question: "If owner withdraws GH¢2,000 cash:",
  options: ["assets decrease and capital decreases", "assets increase", "liability increases", "no change"],
  answer: "assets decrease and capital decreases"
},
{
  question: "If a business owes GH¢4,000 to supplier, it is:",
  options: ["liability", "asset", "expense", "income"],
  answer: "liability"
},
{
  question: "If machinery GH¢10,000 is purchased on credit:",
  options: ["asset increases and liability increases", "asset decreases", "capital increases", "expense"],
  answer: "asset increases and liability increases"
},
{
  question: "Which account is debited when goods are purchased?",
  options: ["purchases account", "sales account", "cash account", "capital"],
  answer: "purchases account"
},
{
  question: "If business receives loan GH¢5,000:",
  options: ["asset increases, liability increases", "asset decreases", "capital increases", "expense increases"],
  answer: "asset increases, liability increases"
},
{
  question: "If expenses exceed revenue, result is:",
  options: ["loss", "profit", "asset increase", "liability decrease"],
  answer: "loss"
},
{
  question: "If revenue exceeds expenses, result is:",
  options: ["profit", "loss", "asset decrease", "liability increase"],
  answer: "profit"
},
{
  question: "Double entry means:",
  options: ["every transaction has two effects", "one entry only", "no entry", "three entries"],
  answer: "every transaction has two effects"
},
{
  question: "Debit the receiver, credit the giver applies to:",
  options: ["personal accounts", "real accounts", "nominal accounts", "ledger"],
  answer: "personal accounts"
},
{
  question: "Debit what comes in applies to:",
  options: ["real accounts", "personal accounts", "nominal accounts", "capital"],
  answer: "real accounts"
},
{
  question: "Debit expenses applies to:",
  options: ["nominal accounts", "real accounts", "personal accounts", "assets"],
  answer: "nominal accounts"
},
{
  question: "Accurate accounting ensures:",
  options: ["reliable financial information", "higher cost", "lower output", "reduced planning"],
  answer: "reliable financial information"
},

{
  question: "The cash book is used to record:",
  options: ["cash and bank transactions", "credit sales only", "credit purchases only", "expenses only"],
  answer: "cash and bank transactions"
},
{
  question: "A three-column cash book contains:",
  options: ["cash, bank, and discount columns", "cash only", "bank only", "sales and purchases"],
  answer: "cash, bank, and discount columns"
},
{
  question: "Discount allowed is recorded on:",
  options: ["debit side", "credit side", "both sides", "none"],
  answer: "debit side"
},
{
  question: "Discount received is recorded on:",
  options: ["credit side", "debit side", "both sides", "none"],
  answer: "credit side"
},
{
  question: "When cash is deposited into bank:",
  options: ["credit cash, debit bank", "debit cash, credit bank", "credit both", "debit both"],
  answer: "credit cash, debit bank"
},
{
  question: "When cash is withdrawn from bank for office use:",
  options: ["debit cash, credit bank", "credit cash, debit bank", "debit both", "credit both"],
  answer: "debit cash, credit bank"
},
{
  question: "A business receives GH¢2,000 cash from debtor with GH¢100 discount allowed. Cash received is:",
  options: ["GH¢1,900", "GH¢2,000", "GH¢2,100", "GH¢100"],
  answer: "GH¢1,900"
},
{
  question: "In the above transaction, discount allowed is:",
  options: ["GH¢100", "GH¢1,900", "GH¢2,000", "GH¢0"],
  answer: "GH¢100"
},
{
  question: "A business pays GH¢1,800 to creditor with GH¢200 discount received. Total payable was:",
  options: ["GH¢2,000", "GH¢1,800", "GH¢200", "GH¢1,600"],
  answer: "GH¢2,000"
},
{
  question: "The balancing figure in cash book is:",
  options: ["cash balance", "profit", "loss", "liability"],
  answer: "cash balance"
},
{
  question: "Cash book never shows:",
  options: ["credit balance", "debit balance", "receipts", "payments"],
  answer: "credit balance"
},
{
  question: "Petty cash book is used for:",
  options: ["small expenses", "large transactions", "sales", "purchases"],
  answer: "small expenses"
},
{
  question: "Imprest system means:",
  options: ["fixed petty cash amount maintained", "variable amount", "no control", "credit system"],
  answer: "fixed petty cash amount maintained"
},
{
  question: "If imprest is GH¢500 and expenses GH¢350, reimbursement is:",
  options: ["GH¢350", "GH¢500", "GH¢150", "GH¢200"],
  answer: "GH¢350"
},
{
  question: "Ledger is:",
  options: ["principal book of accounts", "cash book", "journal", "invoice"],
  answer: "principal book of accounts"
},
{
  question: "Posting means:",
  options: ["transferring entries to ledger", "recording in journal", "calculating profit", "balancing account"],
  answer: "transferring entries to ledger"
},
{
  question: "Debit entry in cash book is posted to ledger as:",
  options: ["credit", "debit", "ignored", "both"],
  answer: "credit"
},
{
  question: "Credit entry in cash book is posted as:",
  options: ["debit", "credit", "ignored", "both"],
  answer: "debit"
},
{
  question: "Sales on credit are recorded in:",
  options: ["sales day book", "cash book", "purchases book", "ledger"],
  answer: "sales day book"
},
{
  question: "Purchases on credit are recorded in:",
  options: ["purchases day book", "cash book", "sales book", "ledger"],
  answer: "purchases day book"
},
{
  question: "Returns inward are recorded in:",
  options: ["sales return book", "purchases book", "cash book", "ledger"],
  answer: "sales return book"
},
{
  question: "Returns outward are recorded in:",
  options: ["purchases return book", "sales book", "cash book", "ledger"],
  answer: "purchases return book"
},
{
  question: "A debit balance in ledger represents:",
  options: ["asset or expense", "liability", "income", "profit"],
  answer: "asset or expense"
},
{
  question: "A credit balance represents:",
  options: ["liability or income", "asset", "expense", "loss"],
  answer: "liability or income"
},
{
  question: "If total debit exceeds credit, balance is:",
  options: ["debit balance", "credit balance", "zero", "loss"],
  answer: "debit balance"
},
{
  question: "If total credit exceeds debit, balance is:",
  options: ["credit balance", "debit balance", "zero", "profit"],
  answer: "credit balance"
},
{
  question: "A customer pays GH¢500. Entry:",
  options: ["debit cash, credit debtor", "credit cash, debit debtor", "debit debtor", "credit sales"],
  answer: "debit cash, credit debtor"
},
{
  question: "Goods bought for cash GH¢1,000:",
  options: ["debit purchases, credit cash", "credit purchases", "debit cash", "credit sales"],
  answer: "debit purchases, credit cash"
},
{
  question: "Owner withdraws GH¢300:",
  options: ["debit drawings, credit cash", "debit cash", "credit capital", "debit sales"],
  answer: "debit drawings, credit cash"
},
{
  question: "Balancing an account ensures:",
  options: ["accuracy of records", "profit increase", "cost reduction", "sales increase"],
  answer: "accuracy of records"
},

{
  question: "Value Added Tax (VAT) is:",
  options: ["tax on value added at each stage", "tax on profit", "income tax", "property tax"],
  answer: "tax on value added at each stage"
},
{
  question: "Output VAT is:",
  options: ["VAT charged on sales", "VAT paid on purchases", "tax on income", "tax on capital"],
  answer: "VAT charged on sales"
},
{
  question: "Input VAT is:",
  options: ["VAT paid on purchases", "VAT on sales", "tax on profit", "tax on income"],
  answer: "VAT paid on purchases"
},
{
  question: "Net VAT payable is:",
  options: ["output VAT − input VAT", "input − output", "sales − purchases", "profit − tax"],
  answer: "output VAT − input VAT"
},
{
  question: "If output VAT GH¢5,000 and input VAT GH¢3,000, VAT payable is:",
  options: ["GH¢2,000", "GH¢5,000", "GH¢3,000", "GH¢8,000"],
  answer: "GH¢2,000"
},
{
  question: "If input VAT exceeds output VAT:",
  options: ["refund is due", "tax payable increases", "profit increases", "no effect"],
  answer: "refund is due"
},
{
  question: "Goods purchased GH¢10,000, VAT 15%. Input VAT is:",
  options: ["GH¢1,500", "GH¢10,000", "GH¢15,000", "GH¢500"],
  answer: "GH¢1,500"
},
{
  question: "Goods sold GH¢20,000, VAT 15%. Output VAT is:",
  options: ["GH¢3,000", "GH¢2,000", "GH¢1,500", "GH¢5,000"],
  answer: "GH¢3,000"
},
{
  question: "VAT exclusive price means:",
  options: ["price without VAT", "price with VAT", "cost price", "selling price"],
  answer: "price without VAT"
},
{
  question: "VAT inclusive price means:",
  options: ["price including VAT", "price without VAT", "cost only", "profit only"],
  answer: "price including VAT"
},
{
  question: "If VAT rate is 15% and price GH¢115, VAT amount is:",
  options: ["GH¢15", "GH¢115", "GH¢100", "GH¢10"],
  answer: "GH¢15"
},
{
  question: "If VAT inclusive price GH¢230 and VAT rate 15%, VAT amount is:",
  options: ["GH¢30", "GH¢15", "GH¢200", "GH¢45"],
  answer: "GH¢30"
},
{
  question: "Net sales (excluding VAT) from GH¢230 is:",
  options: ["GH¢200", "GH¢230", "GH¢30", "GH¢215"],
  answer: "GH¢200"
},
{
  question: "VAT control account shows:",
  options: ["VAT payable or receivable", "profit", "sales", "expenses"],
  answer: "VAT payable or receivable"
},
{
  question: "Output VAT is credited to:",
  options: ["VAT account", "sales account", "cash account", "capital"],
  answer: "VAT account"
},
{
  question: "Input VAT is debited to:",
  options: ["VAT account", "sales account", "cash", "capital"],
  answer: "VAT account"
},
{
  question: "If output VAT GH¢6,000 and input VAT GH¢4,000, balance in VAT account is:",
  options: ["GH¢2,000 payable", "GH¢2,000 receivable", "GH¢6,000", "GH¢4,000"],
  answer: "GH¢2,000 payable"
},
{
  question: "If input VAT GH¢5,000 and output VAT GH¢3,000:",
  options: ["GH¢2,000 receivable", "GH¢2,000 payable", "GH¢5,000", "GH¢3,000"],
  answer: "GH¢2,000 receivable"
},
{
  question: "VAT is paid to:",
  options: ["government", "owners", "employees", "customers"],
  answer: "government"
},
{
  question: "VAT is collected from:",
  options: ["customers", "suppliers", "employees", "government"],
  answer: "customers"
},
{
  question: "If sales GH¢50,000, VAT 15%, total invoice is:",
  options: ["GH¢57,500", "GH¢50,000", "GH¢7,500", "GH¢60,000"],
  answer: "GH¢57,500"
},
{
  question: "If purchases GH¢40,000, VAT 15%, total cost is:",
  options: ["GH¢46,000", "GH¢40,000", "GH¢6,000", "GH¢50,000"],
  answer: "GH¢46,000"
},
{
  question: "VAT does not apply to:",
  options: ["exempt goods", "sales", "purchases", "services"],
  answer: "exempt goods"
},
{
  question: "VAT registered business must:",
  options: ["charge VAT on sales", "ignore VAT", "pay income tax only", "avoid records"],
  answer: "charge VAT on sales"
},
{
  question: "VAT return is submitted:",
  options: ["periodically", "daily", "once only", "never"],
  answer: "periodically"
},
{
  question: "If VAT is not paid on time:",
  options: ["penalty applies", "profit increases", "cost decreases", "no effect"],
  answer: "penalty applies"
},
{
  question: "VAT increases selling price by:",
  options: ["tax percentage", "fixed amount", "zero", "profit"],
  answer: "tax percentage"
},
{
  question: "VAT is classified as:",
  options: ["indirect tax", "direct tax", "income tax", "profit tax"],
  answer: "indirect tax"
},
{
  question: "Correct VAT accounting ensures:",
  options: ["compliance with law", "higher cost", "low profit", "reduced sales"],
  answer: "compliance with law"
},
{
  question: "A business failing to record VAT properly may:",
  options: ["face penalties", "increase profit", "reduce cost", "improve efficiency"],
  answer: "face penalties"
},

{
  question: "Trading account is prepared to determine:",
  options: ["gross profit", "net profit", "capital", "expenses"],
  answer: "gross profit"
},
{
  question: "Gross profit =",
  options: ["sales − cost of goods sold", "sales − expenses", "profit − cost", "capital − liabilities"],
  answer: "sales − cost of goods sold"
},
{
  question: "Cost of goods sold =",
  options: ["opening stock + purchases − closing stock", "sales − profit", "purchases only", "stock only"],
  answer: "opening stock + purchases − closing stock"
},
{
  question: "If opening stock GH¢5,000, purchases GH¢15,000, closing stock GH¢4,000, COGS is:",
  options: ["GH¢16,000", "GH¢20,000", "GH¢10,000", "GH¢6,000"],
  answer: "GH¢16,000"
},
{
  question: "If sales GH¢25,000 and COGS GH¢16,000, gross profit is:",
  options: ["GH¢9,000", "GH¢16,000", "GH¢25,000", "GH¢7,000"],
  answer: "GH¢9,000"
},
{
  question: "Profit and Loss account determines:",
  options: ["net profit", "gross profit", "sales", "stock"],
  answer: "net profit"
},
{
  question: "Net profit =",
  options: ["gross profit − expenses", "sales − purchases", "assets − liabilities", "capital − drawings"],
  answer: "gross profit − expenses"
},
{
  question: "If gross profit GH¢9,000 and expenses GH¢4,000, net profit is:",
  options: ["GH¢5,000", "GH¢9,000", "GH¢4,000", "GH¢13,000"],
  answer: "GH¢5,000"
},
{
  question: "Balance sheet shows:",
  options: ["financial position", "profit", "sales", "expenses"],
  answer: "financial position"
},
{
  question: "Assets are:",
  options: ["resources owned by business", "debts", "expenses", "losses"],
  answer: "resources owned by business"
},
{
  question: "Liabilities are:",
  options: ["debts owed", "assets", "profit", "expenses"],
  answer: "debts owed"
},
{
  question: "Capital is:",
  options: ["owner’s interest", "liability", "expense", "asset"],
  answer: "owner’s interest"
},
{
  question: "Closing stock appears in:",
  options: ["trading account and balance sheet", "P&L only", "cash book", "ledger"],
  answer: "trading account and balance sheet"
},
{
  question: "Carriage inward is added to:",
  options: ["purchases", "sales", "expenses", "capital"],
  answer: "purchases"
},
{
  question: "Carriage outward is:",
  options: ["expense", "asset", "liability", "income"],
  answer: "expense"
},
{
  question: "Discount allowed is:",
  options: ["expense", "income", "asset", "liability"],
  answer: "expense"
},
{
  question: "Discount received is:",
  options: ["income", "expense", "asset", "liability"],
  answer: "income"
},
{
  question: "Depreciation is:",
  options: ["expense", "income", "asset", "liability"],
  answer: "expense"
},
{
  question: "Accrued expenses are:",
  options: ["added to expenses", "deducted", "ignored", "income"],
  answer: "added to expenses"
},
{
  question: "Prepaid expenses are:",
  options: ["deducted from expenses", "added", "ignored", "income"],
  answer: "deducted from expenses"
},
{
  question: "If rent GH¢2,000 and prepaid GH¢500, expense is:",
  options: ["GH¢1,500", "GH¢2,000", "GH¢2,500", "GH¢500"],
  answer: "GH¢1,500"
},
{
  question: "If wages GH¢3,000 and accrued GH¢500, total expense is:",
  options: ["GH¢3,500", "GH¢3,000", "GH¢2,500", "GH¢500"],
  answer: "GH¢3,500"
},
{
  question: "Bad debts are:",
  options: ["expense", "income", "asset", "liability"],
  answer: "expense"
},
{
  question: "Provision for bad debts is:",
  options: ["deducted from debtors", "added to debtors", "ignored", "income"],
  answer: "deducted from debtors"
},
{
  question: "Drawings reduce:",
  options: ["capital", "assets", "liabilities", "income"],
  answer: "capital"
},
{
  question: "If capital GH¢20,000, drawings GH¢5,000, new capital is:",
  options: ["GH¢15,000", "GH¢20,000", "GH¢25,000", "GH¢5,000"],
  answer: "GH¢15,000"
},
{
  question: "Net profit increases:",
  options: ["capital", "liabilities", "expenses", "drawings"],
  answer: "capital"
},
{
  question: "If capital GH¢15,000 and profit GH¢5,000:",
  options: ["GH¢20,000", "GH¢15,000", "GH¢10,000", "GH¢5,000"],
  answer: "GH¢20,000"
},
{
  question: "Trial balance ensures:",
  options: ["arithmetical accuracy", "profit", "sales", "expenses"],
  answer: "arithmetical accuracy"
},
{
  question: "Final accounts help in:",
  options: ["decision making", "recording transactions", "posting", "journalizing"],
  answer: "decision making"
},

{
  question: "A machine costing GH¢12,000 with residual value GH¢2,000 and useful life of 5 years is depreciated using straight line method. Annual depreciation is:",
  options: ["GH¢2,000", "GH¢2,400", "GH¢1,000", "GH¢3,000"],
  answer: "GH¢2,000"
},
{
  question: "An asset costing GH¢15,000 is depreciated at 10% per annum using reducing balance method. Depreciation for the first year is:",
  options: ["GH¢1,500", "GH¢1,000", "GH¢2,000", "GH¢1,200"],
  answer: "GH¢1,500"
},
{
  question: "A machine costing GH¢10,000 is depreciated at 10% per annum using reducing balance method. What is the depreciation for the second year?",
  options: ["GH¢900", "GH¢1,000", "GH¢800", "GH¢950"],
  answer: "GH¢900"
},
{
  question: "An asset costs GH¢20,000 and accumulated depreciation is GH¢6,000. Net book value is:",
  options: ["GH¢14,000", "GH¢20,000", "GH¢6,000", "GH¢26,000"],
  answer: "GH¢14,000"
},
{
  question: "A business writes off GH¢500 as bad debts. This is treated as:",
  options: ["expense", "income", "asset", "liability"],
  answer: "expense"
},
{
  question: "A business has debtors of GH¢8,000 and creates a provision of 5%. Provision amount is:",
  options: ["GH¢400", "GH¢800", "GH¢200", "GH¢500"],
  answer: "GH¢400"
},
{
  question: "A business has old provision GH¢300 and new provision GH¢500. Increase in provision is:",
  options: ["GH¢200 expense", "GH¢200 income", "GH¢300", "GH¢500"],
  answer: "GH¢200 expense"
},
{
  question: "A business has old provision GH¢700 and new provision GH¢400. Decrease in provision is:",
  options: ["GH¢300 income", "GH¢300 expense", "GH¢700", "GH¢400"],
  answer: "GH¢300 income"
},
{
  question: "A debtor owing GH¢1,200 is declared bankrupt and only GH¢200 is recovered. Bad debt is:",
  options: ["GH¢1,000", "GH¢1,200", "GH¢200", "GH¢800"],
  answer: "GH¢1,000"
},
{
  question: "A business has debtors GH¢10,000 and provision for doubtful debts at 5%. Net debtors is:",
  options: ["GH¢9,500", "GH¢10,000", "GH¢5,000", "GH¢9,000"],
  answer: "GH¢9,500"
},
{
  question: "Rent paid during the year is GH¢3,000 but GH¢500 relates to next year. Adjusted rent is:",
  options: ["GH¢2,500", "GH¢3,000", "GH¢3,500", "GH¢500"],
  answer: "GH¢2,500"
},
{
  question: "Wages paid GH¢4,000 but GH¢600 is outstanding. Adjusted wages is:",
  options: ["GH¢4,600", "GH¢4,000", "GH¢3,400", "GH¢600"],
  answer: "GH¢4,600"
},
{
  question: "Insurance paid GH¢2,400 covering 12 months, but 3 months is prepaid. Expense is:",
  options: ["GH¢1,800", "GH¢2,400", "GH¢600", "GH¢2,000"],
  answer: "GH¢1,800"
},
{
  question: "Commission earned GH¢1,200 but GH¢300 is accrued. Total income is:",
  options: ["GH¢1,500", "GH¢1,200", "GH¢900", "GH¢300"],
  answer: "GH¢1,500"
},
{
  question: "Electricity bill GH¢2,000 includes GH¢400 unpaid. Expense is:",
  options: ["GH¢2,400", "GH¢2,000", "GH¢1,600", "GH¢400"],
  answer: "GH¢2,400"
},
{
  question: "Prepaid expenses are shown in balance sheet as:",
  options: ["asset", "liability", "income", "expense"],
  answer: "asset"
},
{
  question: "Accrued expenses are shown as:",
  options: ["liability", "asset", "income", "expense"],
  answer: "liability"
},
{
  question: "Depreciation is charged to:",
  options: ["profit and loss account", "balance sheet only", "cash book", "ledger"],
  answer: "profit and loss account"
},
{
  question: "Accumulated depreciation appears in balance sheet as:",
  options: ["deduction from asset", "liability", "income", "expense"],
  answer: "deduction from asset"
},
{
  question: "Provision for doubtful debts is shown as:",
  options: ["deduction from debtors", "liability", "income", "asset"],
  answer: "deduction from debtors"
},
{
  question: "A business fails to record accrued expenses. Profit will be:",
  options: ["overstated", "understated", "correct", "zero"],
  answer: "overstated"
},
{
  question: "If prepaid expenses are ignored, profit will be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "If depreciation is not charged, profit will be:",
  options: ["overstated", "understated", "correct", "zero"],
  answer: "overstated"
},
{
  question: "If bad debts are ignored, profit will be:",
  options: ["overstated", "understated", "correct", "zero"],
  answer: "overstated"
},
{
  question: "If provision is increased, profit will:",
  options: ["decrease", "increase", "remain same", "double"],
  answer: "decrease"
},
{
  question: "If provision decreases, profit will:",
  options: ["increase", "decrease", "same", "zero"],
  answer: "increase"
},
{
  question: "Adjustment entries ensure:",
  options: ["true and fair view", "higher profit", "lower cost", "less work"],
  answer: "true and fair view"
},
{
  question: "Ignoring adjustments leads to:",
  options: ["incorrect financial statements", "accurate results", "higher efficiency", "lower cost"],
  answer: "incorrect financial statements"
},
{
  question: "Accrual concept ensures:",
  options: ["income and expenses matched", "cash basis only", "profit ignored", "cost reduced"],
  answer: "income and expenses matched"
},
{
  question: "Consistency concept means:",
  options: ["same methods used over time", "changing methods always", "no records", "random methods"],
  answer: "same methods used over time"
},

{
  question: "A sales ledger control account is used to summarize:",
  options: ["total debtors", "total creditors", "cash transactions", "expenses"],
  answer: "total debtors"
},
{
  question: "A purchases ledger control account shows:",
  options: ["total creditors", "total debtors", "cash", "expenses"],
  answer: "total creditors"
},
{
  question: "Opening debtors GH¢5,000, credit sales GH¢20,000, cash received GH¢15,000. Closing debtors is:",
  options: ["GH¢10,000", "GH¢5,000", "GH¢20,000", "GH¢15,000"],
  answer: "GH¢10,000"
},
{
  question: "Opening creditors GH¢4,000, credit purchases GH¢10,000, cash paid GH¢8,000. Closing creditors is:",
  options: ["GH¢6,000", "GH¢4,000", "GH¢10,000", "GH¢8,000"],
  answer: "GH¢6,000"
},
{
  question: "Opening debtors GH¢6,000, closing GH¢8,000, credit sales GH¢20,000. Cash received is:",
  options: ["GH¢18,000", "GH¢20,000", "GH¢14,000", "GH¢22,000"],
  answer: "GH¢18,000"
},
{
  question: "Opening creditors GH¢3,000, closing GH¢5,000, credit purchases GH¢12,000. Cash paid is:",
  options: ["GH¢10,000", "GH¢12,000", "GH¢8,000", "GH¢5,000"],
  answer: "GH¢10,000"
},
{
  question: "Discount allowed is recorded in control account as:",
  options: ["credit", "debit", "ignored", "liability"],
  answer: "credit"
},
{
  question: "Discount received is recorded as:",
  options: ["debit", "credit", "ignored", "asset"],
  answer: "debit"
},
{
  question: "Returns inward reduces:",
  options: ["debtors", "creditors", "cash", "capital"],
  answer: "debtors"
},
{
  question: "Returns outward reduces:",
  options: ["creditors", "debtors", "cash", "expenses"],
  answer: "creditors"
},
{
  question: "Bad debts written off are recorded as:",
  options: ["credit in control account", "debit", "ignored", "income"],
  answer: "credit in control account"
},
{
  question: "Opening debtors GH¢10,000, credit sales GH¢30,000, returns GH¢2,000, bad debts GH¢3,000, cash GH¢20,000. Closing debtors:",
  options: ["GH¢15,000", "GH¢10,000", "GH¢5,000", "GH¢20,000"],
  answer: "GH¢15,000"
},
{
  question: "Opening creditors GH¢8,000, purchases GH¢25,000, returns GH¢5,000, payments GH¢18,000. Closing creditors:",
  options: ["GH¢10,000", "GH¢8,000", "GH¢12,000", "GH¢5,000"],
  answer: "GH¢10,000"
},
{
  question: "Control accounts help to:",
  options: ["detect errors", "increase cost", "reduce profit", "ignore records"],
  answer: "detect errors"
},
{
  question: "If control account balance differs from ledger total, it indicates:",
  options: ["error exists", "profit increase", "loss", "no issue"],
  answer: "error exists"
},
{
  question: "Sales ledger control account normally has:",
  options: ["debit balance", "credit balance", "zero", "loss"],
  answer: "debit balance"
},
{
  question: "Purchases ledger control account normally has:",
  options: ["credit balance", "debit balance", "zero", "profit"],
  answer: "credit balance"
},
{
  question: "Opening debtors GH¢7,000, closing GH¢9,000, cash received GH¢15,000, returns GH¢1,000. Credit sales:",
  options: ["GH¢18,000", "GH¢15,000", "GH¢16,000", "GH¢20,000"],
  answer: "GH¢18,000"
},
{
  question: "Opening creditors GH¢6,000, closing GH¢4,000, payments GH¢12,000, returns GH¢2,000. Credit purchases:",
  options: ["GH¢12,000", "GH¢10,000", "GH¢8,000", "GH¢14,000"],
  answer: "GH¢12,000"
},
{
  question: "Dishonoured cheque from debtor increases:",
  options: ["debtors", "creditors", "cash", "expenses"],
  answer: "debtors"
},
{
  question: "Interest charged on overdue account increases:",
  options: ["debtors", "creditors", "cash", "expenses"],
  answer: "debtors"
},
{
  question: "Interest received from creditor reduces:",
  options: ["creditors", "debtors", "cash", "expenses"],
  answer: "creditors"
},
{
  question: "Contra entry affects:",
  options: ["cash and bank", "debtors only", "creditors only", "expenses"],
  answer: "cash and bank"
},
{
  question: "If debtor returns goods GH¢500, effect:",
  options: ["reduce debtors", "increase debtors", "increase cash", "reduce expenses"],
  answer: "reduce debtors"
},
{
  question: "If creditor grants discount GH¢300:",
  options: ["reduce creditors", "increase creditors", "increase cash", "reduce debtors"],
  answer: "reduce creditors"
},
{
  question: "If goods sold on credit GH¢5,000:",
  options: ["increase debtors", "increase creditors", "reduce cash", "increase expenses"],
  answer: "increase debtors"
},
{
  question: "If goods purchased on credit GH¢4,000:",
  options: ["increase creditors", "increase debtors", "reduce cash", "increase expenses"],
  answer: "increase creditors"
},
{
  question: "Control account reconciliation ensures:",
  options: ["accuracy of records", "profit increase", "cost reduction", "sales increase"],
  answer: "accuracy of records"
},
{
  question: "Difference in control account may arise due to:",
  options: ["omissions or errors", "profit", "sales", "cash"],
  answer: "omissions or errors"
},
{
  question: "Correct use of control accounts improves:",
  options: ["internal control system", "cost increase", "profit reduction", "sales decrease"],
  answer: "internal control system"
},

{
  question: "Incomplete records system is also known as:",
  options: ["single entry system", "double entry system", "ledger system", "journal system"],
  answer: "single entry system"
},
{
  question: "Statement of affairs is similar to:",
  options: ["balance sheet", "trading account", "cash book", "journal"],
  answer: "balance sheet"
},
{
  question: "Capital =",
  options: ["assets − liabilities", "assets + liabilities", "sales − expenses", "profit − drawings"],
  answer: "assets − liabilities"
},
{
  question: "If assets GH¢50,000 and liabilities GH¢20,000, capital is:",
  options: ["GH¢30,000", "GH¢50,000", "GH¢20,000", "GH¢70,000"],
  answer: "GH¢30,000"
},
{
  question: "Opening capital GH¢30,000, closing capital GH¢40,000, drawings GH¢5,000. Profit is:",
  options: ["GH¢15,000", "GH¢10,000", "GH¢5,000", "GH¢20,000"],
  answer: "GH¢15,000"
},
{
  question: "Opening capital GH¢25,000, closing GH¢20,000, drawings GH¢5,000. Result is:",
  options: ["GH¢10,000 loss", "GH¢10,000 profit", "GH¢5,000 loss", "GH¢5,000 profit"],
  answer: "GH¢10,000 loss"
},
{
  question: "Assets increase from GH¢40,000 to GH¢50,000 and liabilities remain GH¢10,000. Increase in capital is:",
  options: ["GH¢10,000", "GH¢5,000", "GH¢20,000", "GH¢0"],
  answer: "GH¢10,000"
},
{
  question: "Opening capital GH¢20,000, additional capital GH¢5,000, closing capital GH¢35,000. Profit is:",
  options: ["GH¢10,000", "GH¢15,000", "GH¢5,000", "GH¢20,000"],
  answer: "GH¢10,000"
},
{
  question: "If drawings GH¢3,000 and capital increased by GH¢8,000, profit is:",
  options: ["GH¢11,000", "GH¢8,000", "GH¢5,000", "GH¢3,000"],
  answer: "GH¢11,000"
},
{
  question: "A business has opening debtors GH¢5,000, closing GH¢7,000, cash received GH¢18,000. Credit sales is:",
  options: ["GH¢20,000", "GH¢18,000", "GH¢16,000", "GH¢25,000"],
  answer: "GH¢20,000"
},
{
  question: "Opening creditors GH¢4,000, closing GH¢6,000, payments GH¢10,000. Credit purchases is:",
  options: ["GH¢12,000", "GH¢10,000", "GH¢8,000", "GH¢6,000"],
  answer: "GH¢12,000"
},
{
  question: "Opening stock GH¢3,000, purchases GH¢12,000, closing stock GH¢5,000. Cost of goods sold is:",
  options: ["GH¢10,000", "GH¢12,000", "GH¢8,000", "GH¢15,000"],
  answer: "GH¢10,000"
},
{
  question: "Sales GH¢20,000, COGS GH¢10,000. Gross profit is:",
  options: ["GH¢10,000", "GH¢20,000", "GH¢5,000", "GH¢15,000"],
  answer: "GH¢10,000"
},
{
  question: "Gross profit GH¢12,000, expenses GH¢7,000. Net profit is:",
  options: ["GH¢5,000", "GH¢12,000", "GH¢7,000", "GH¢19,000"],
  answer: "GH¢5,000"
},
{
  question: "Opening cash GH¢2,000, receipts GH¢10,000, payments GH¢8,000. Closing cash:",
  options: ["GH¢4,000", "GH¢2,000", "GH¢10,000", "GH¢6,000"],
  answer: "GH¢4,000"
},
{
  question: "Cash sales can be determined from:",
  options: ["cash book", "ledger only", "trial balance", "journal"],
  answer: "cash book"
},
{
  question: "Opening debtors GH¢6,000, closing GH¢4,000, credit sales GH¢15,000. Cash received is:",
  options: ["GH¢17,000", "GH¢15,000", "GH¢13,000", "GH¢19,000"],
  answer: "GH¢17,000"
},
{
  question: "Opening creditors GH¢5,000, closing GH¢3,000, purchases GH¢10,000. Payments:",
  options: ["GH¢12,000", "GH¢10,000", "GH¢8,000", "GH¢6,000"],
  answer: "GH¢12,000"
},
{
  question: "If assets are understated, capital will be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "If liabilities are overstated, capital will be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "If drawings are ignored, profit will be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "If additional capital is ignored, profit will be:",
  options: ["overstated", "understated", "correct", "zero"],
  answer: "overstated"
},
{
  question: "Incomplete records system is commonly used by:",
  options: ["small businesses", "large corporations", "banks", "government"],
  answer: "small businesses"
},
{
  question: "Which record is most important in single entry?",
  options: ["cash book", "trial balance", "ledger", "journal"],
  answer: "cash book"
},
{
  question: "Statement of affairs helps to:",
  options: ["find capital", "record transactions", "calculate VAT", "audit accounts"],
  answer: "find capital"
},
{
  question: "Profit in single entry is determined by:",
  options: ["change in capital", "sales − purchases", "assets − liabilities", "cash only"],
  answer: "change in capital"
},
{
  question: "If capital decreases after adjusting drawings, result is:",
  options: ["loss", "profit", "asset", "liability"],
  answer: "loss"
},
{
  question: "Incomplete records lack:",
  options: ["full double entry", "cash records", "sales", "purchases"],
  answer: "full double entry"
},
{
  question: "Accuracy of incomplete records is:",
  options: ["low compared to full accounting", "high", "perfect", "guaranteed"],
  answer: "low compared to full accounting"
},
{
  question: "Proper accounting system ensures:",
  options: ["reliable financial information", "higher cost", "lower output", "reduced profit"],
  answer: "reliable financial information"
},

{
  question: "A club is a:",
  options: ["non-profit organization", "profit-making business", "bank", "government agency"],
  answer: "non-profit organization"
},
{
  question: "Main objective of a club is to:",
  options: ["provide services to members", "maximize profit", "increase capital", "reduce cost"],
  answer: "provide services to members"
},
{
  question: "Receipts and payments account is:",
  options: ["cash summary", "profit statement", "balance sheet", "ledger"],
  answer: "cash summary"
},
{
  question: "Receipts and payments account includes:",
  options: ["all cash transactions", "credit only", "profit only", "expenses only"],
  answer: "all cash transactions"
},
{
  question: "Income and expenditure account is similar to:",
  options: ["profit and loss account", "balance sheet", "cash book", "ledger"],
  answer: "profit and loss account"
},
{
  question: "Income and expenditure account records:",
  options: ["income and expenses for the period", "cash only", "assets", "liabilities"],
  answer: "income and expenses for the period"
},
{
  question: "Subscriptions are:",
  options: ["members’ contributions", "expenses", "assets", "liabilities"],
  answer: "members’ contributions"
},
{
  question: "Subscriptions received in advance are:",
  options: ["liability", "asset", "income", "expense"],
  answer: "liability"
},
{
  question: "Subscriptions outstanding are:",
  options: ["asset", "liability", "expense", "income"],
  answer: "asset"
},
{
  question: "Opening accumulated fund is similar to:",
  options: ["capital", "liability", "expense", "income"],
  answer: "capital"
},
{
  question: "Accumulated fund =",
  options: ["assets − liabilities", "income − expenses", "sales − cost", "profit − drawings"],
  answer: "assets − liabilities"
},
{
  question: "If assets GH¢50,000 and liabilities GH¢20,000, accumulated fund is:",
  options: ["GH¢30,000", "GH¢50,000", "GH¢20,000", "GH¢70,000"],
  answer: "GH¢30,000"
},
{
  question: "Receipts GH¢15,000, payments GH¢10,000. Closing cash is:",
  options: ["GH¢5,000", "GH¢15,000", "GH¢10,000", "GH¢25,000"],
  answer: "GH¢5,000"
},
{
  question: "Receipts and payments account includes:",
  options: ["capital and revenue items", "revenue only", "capital only", "profit only"],
  answer: "capital and revenue items"
},
{
  question: "Income and expenditure excludes:",
  options: ["capital items", "revenue items", "expenses", "income"],
  answer: "capital items"
},
{
  question: "Subscriptions received GH¢5,000, outstanding GH¢1,000, advance GH¢500. Income is:",
  options: ["GH¢5,500", "GH¢5,000", "GH¢4,500", "GH¢6,000"],
  answer: "GH¢5,500"
},
{
  question: "Subscriptions received GH¢6,000, outstanding GH¢500, advance GH¢1,000. Income is:",
  options: ["GH¢5,500", "GH¢6,000", "GH¢6,500", "GH¢4,500"],
  answer: "GH¢5,500"
},
{
  question: "If expenses exceed income, result is:",
  options: ["deficit", "surplus", "profit", "capital"],
  answer: "deficit"
},
{
  question: "If income exceeds expenses, result is:",
  options: ["surplus", "deficit", "loss", "liability"],
  answer: "surplus"
},
{
  question: "Entrance fees are treated as:",
  options: ["income", "liability", "expense", "asset"],
  answer: "income"
},
{
  question: "Donations may be treated as:",
  options: ["capital or income depending on nature", "expense", "liability", "asset"],
  answer: "capital or income depending on nature"
},
{
  question: "Life membership fees are usually:",
  options: ["capital receipt", "revenue income", "expense", "liability"],
  answer: "capital receipt"
},
{
  question: "Purchase of equipment is:",
  options: ["capital expenditure", "revenue expenditure", "income", "liability"],
  answer: "capital expenditure"
},
{
  question: "Payment of wages is:",
  options: ["revenue expenditure", "capital expenditure", "asset", "liability"],
  answer: "revenue expenditure"
},
{
  question: "Accumulated fund increases when:",
  options: ["surplus occurs", "deficit occurs", "expenses increase", "income decreases"],
  answer: "surplus occurs"
},
{
  question: "Accumulated fund decreases when:",
  options: ["deficit occurs", "surplus occurs", "income increases", "assets increase"],
  answer: "deficit occurs"
},
{
  question: "Receipts and payments account starts with:",
  options: ["opening cash balance", "profit", "expenses", "capital"],
  answer: "opening cash balance"
},
{
  question: "Closing balance in receipts and payments represents:",
  options: ["cash/bank balance", "profit", "loss", "liability"],
  answer: "cash/bank balance"
},
{
  question: "Income and expenditure account helps to determine:",
  options: ["surplus or deficit", "cash balance", "capital", "assets"],
  answer: "surplus or deficit"
},
{
  question: "Proper accounting in clubs ensures:",
  options: ["accountability", "profit maximization", "tax reduction", "cost increase"],
  answer: "accountability"
},

{
  question: "Manufacturing account is prepared to determine:",
  options: ["cost of production", "net profit", "gross profit", "capital"],
  answer: "cost of production"
},
{
  question: "Prime cost =",
  options: ["direct materials + direct labour + direct expenses", "materials + overhead", "labour + overhead", "sales − cost"],
  answer: "direct materials + direct labour + direct expenses"
},
{
  question: "Direct materials GH¢8,000, direct labour GH¢5,000, direct expenses GH¢2,000. Prime cost is:",
  options: ["GH¢15,000", "GH¢13,000", "GH¢10,000", "GH¢8,000"],
  answer: "GH¢15,000"
},
{
  question: "Factory overhead includes:",
  options: ["indirect costs", "direct labour", "materials", "sales"],
  answer: "indirect costs"
},
{
  question: "Production cost =",
  options: ["prime cost + factory overhead", "prime cost − overhead", "sales − cost", "profit + cost"],
  answer: "prime cost + factory overhead"
},
{
  question: "Prime cost GH¢15,000, overhead GH¢5,000. Production cost is:",
  options: ["GH¢20,000", "GH¢15,000", "GH¢10,000", "GH¢5,000"],
  answer: "GH¢20,000"
},
{
  question: "Opening raw materials GH¢4,000, purchases GH¢12,000, closing GH¢3,000. Materials used:",
  options: ["GH¢13,000", "GH¢16,000", "GH¢12,000", "GH¢9,000"],
  answer: "GH¢13,000"
},
{
  question: "Opening WIP GH¢2,000, closing WIP GH¢3,000, production cost GH¢20,000. Cost of production:",
  options: ["GH¢19,000", "GH¢20,000", "GH¢21,000", "GH¢22,000"],
  answer: "GH¢19,000"
},
{
  question: "If opening WIP GH¢1,000, closing GH¢2,000, production cost GH¢15,000. Final cost:",
  options: ["GH¢14,000", "GH¢15,000", "GH¢16,000", "GH¢13,000"],
  answer: "GH¢14,000"
},
{
  question: "Cost of production is transferred to:",
  options: ["trading account", "P&L", "balance sheet", "cash book"],
  answer: "trading account"
},
{
  question: "Factory rent is:",
  options: ["overhead", "direct cost", "income", "liability"],
  answer: "overhead"
},
{
  question: "Indirect labour is:",
  options: ["overhead", "direct labour", "asset", "income"],
  answer: "overhead"
},
{
  question: "Direct labour is:",
  options: ["part of prime cost", "overhead", "expense only", "income"],
  answer: "part of prime cost"
},
{
  question: "If materials used GH¢10,000, labour GH¢6,000, expenses GH¢2,000, prime cost:",
  options: ["GH¢18,000", "GH¢16,000", "GH¢12,000", "GH¢10,000"],
  answer: "GH¢18,000"
},
{
  question: "If prime cost GH¢18,000 and overhead GH¢7,000, production cost:",
  options: ["GH¢25,000", "GH¢18,000", "GH¢7,000", "GH¢20,000"],
  answer: "GH¢25,000"
},
{
  question: "Opening stock of raw materials GH¢5,000, purchases GH¢20,000, closing GH¢4,000. Materials used:",
  options: ["GH¢21,000", "GH¢25,000", "GH¢20,000", "GH¢19,000"],
  answer: "GH¢21,000"
},
{
  question: "If factory overhead GH¢8,000 and prime cost GH¢22,000, production cost:",
  options: ["GH¢30,000", "GH¢22,000", "GH¢8,000", "GH¢14,000"],
  answer: "GH¢30,000"
},
{
  question: "Work-in-progress represents:",
  options: ["partially completed goods", "finished goods", "raw materials", "sales"],
  answer: "partially completed goods"
},
{
  question: "Increase in closing WIP reduces:",
  options: ["cost of production", "profit", "sales", "assets"],
  answer: "cost of production"
},
{
  question: "Decrease in closing WIP increases:",
  options: ["cost of production", "profit", "assets", "liabilities"],
  answer: "cost of production"
},
{
  question: "Manufacturing account focuses on:",
  options: ["production cost only", "profit", "sales", "assets"],
  answer: "production cost only"
},
{
  question: "Factory lighting is:",
  options: ["overhead", "direct cost", "asset", "income"],
  answer: "overhead"
},
{
  question: "Cost of production helps in:",
  options: ["pricing decisions", "tax calculation", "sales recording", "auditing"],
  answer: "pricing decisions"
},
{
  question: "If production cost GH¢30,000 and output 3,000 units, cost per unit:",
  options: ["GH¢10", "GH¢30", "GH¢5", "GH¢15"],
  answer: "GH¢10"
},
{
  question: "If production cost GH¢25,000 and output 5,000 units, cost/unit:",
  options: ["GH¢5", "GH¢10", "GH¢25", "GH¢20"],
  answer: "GH¢5"
},
{
  question: "Proper manufacturing accounting ensures:",
  options: ["accurate cost control", "higher cost", "lower output", "loss"],
  answer: "accurate cost control"
},
{
  question: "If overhead is ignored, production cost will be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "If direct labour is omitted, prime cost will be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "Manufacturing accounts are prepared by:",
  options: ["manufacturing firms", "banks", "clubs", "government"],
  answer: "manufacturing firms"
},
{
  question: "Accurate cost helps management to:",
  options: ["make better decisions", "increase cost", "reduce profit", "ignore planning"],
  answer: "make better decisions"
},

{
  question: "A partnership is formed by:",
  options: ["two or more persons", "one person", "government", "company only"],
  answer: "two or more persons"
},
{
  question: "Profit sharing ratio determines:",
  options: ["how profit is divided", "capital amount", "expenses", "assets"],
  answer: "how profit is divided"
},
{
  question: "If A and B share profit 2:1 and profit GH¢9,000, A receives:",
  options: ["GH¢6,000", "GH¢3,000", "GH¢4,500", "GH¢9,000"],
  answer: "GH¢6,000"
},
{
  question: "If A and B share 3:2 and profit GH¢10,000, B receives:",
  options: ["GH¢4,000", "GH¢6,000", "GH¢5,000", "GH¢3,000"],
  answer: "GH¢4,000"
},
{
  question: "Interest on capital is:",
  options: ["appropriation of profit", "expense", "liability", "income"],
  answer: "appropriation of profit"
},
{
  question: "Salary to partner is:",
  options: ["appropriation of profit", "expense", "asset", "liability"],
  answer: "appropriation of profit"
},
{
  question: "Interest on drawings is:",
  options: ["income to business", "expense", "asset", "liability"],
  answer: "income to business"
},
{
  question: "A partner’s capital account shows:",
  options: ["long-term investment", "expenses", "sales", "liabilities"],
  answer: "long-term investment"
},
{
  question: "Current account records:",
  options: ["short-term changes", "capital only", "assets", "liabilities"],
  answer: "short-term changes"
},
{
  question: "If A capital GH¢20,000, interest 10%, interest is:",
  options: ["GH¢2,000", "GH¢1,000", "GH¢500", "GH¢3,000"],
  answer: "GH¢2,000"
},
{
  question: "If drawings GH¢5,000 and interest 5%, interest on drawings:",
  options: ["GH¢250", "GH¢500", "GH¢5,000", "GH¢100"],
  answer: "GH¢250"
},
{
  question: "Profit GH¢12,000, A salary GH¢2,000, remaining shared equally. Each gets:",
  options: ["GH¢5,000", "GH¢6,000", "GH¢4,000", "GH¢3,000"],
  answer: "GH¢5,000"
},
{
  question: "Goodwill represents:",
  options: ["value of reputation", "cash", "stock", "liability"],
  answer: "value of reputation"
},
{
  question: "If goodwill valued GH¢9,000 and partners share equally, each share:",
  options: ["GH¢4,500", "GH¢3,000", "GH¢9,000", "GH¢6,000"],
  answer: "GH¢4,500"
},
{
  question: "Revaluation account is prepared to:",
  options: ["adjust asset values", "calculate profit", "record sales", "prepare ledger"],
  answer: "adjust asset values"
},
{
  question: "Increase in asset value is:",
  options: ["credited to revaluation", "debited", "ignored", "expense"],
  answer: "credited to revaluation"
},
{
  question: "Decrease in asset value is:",
  options: ["debited to revaluation", "credited", "ignored", "income"],
  answer: "debited to revaluation"
},
{
  question: "If asset increases GH¢5,000 and liability increases GH¢2,000, profit:",
  options: ["GH¢3,000", "GH¢5,000", "GH¢2,000", "GH¢7,000"],
  answer: "GH¢3,000"
},
{
  question: "Admission of a new partner requires:",
  options: ["revaluation and goodwill adjustment", "no change", "closing business", "liquidation"],
  answer: "revaluation and goodwill adjustment"
},
{
  question: "If new partner brings GH¢10,000 capital:",
  options: ["increase capital", "increase expense", "reduce profit", "increase liability"],
  answer: "increase capital"
},
{
  question: "Dissolution means:",
  options: ["closing partnership", "starting business", "profit sharing", "expansion"],
  answer: "closing partnership"
},
{
  question: "Realization account is used during:",
  options: ["dissolution", "normal trading", "sales", "purchase"],
  answer: "dissolution"
},
{
  question: "Sale of asset during dissolution is credited to:",
  options: ["realization account", "cash book", "capital", "expense"],
  answer: "realization account"
},
{
  question: "Realization expenses are:",
  options: ["debited to realization", "credited", "ignored", "asset"],
  answer: "debited to realization"
},
{
  question: "If realization profit occurs, it is shared:",
  options: ["in profit sharing ratio", "equally", "ignored", "to one partner"],
  answer: "in profit sharing ratio"
},
{
  question: "If realization loss occurs, it is shared:",
  options: ["in profit sharing ratio", "ignored", "to creditor", "to bank"],
  answer: "in profit sharing ratio"
},
{
  question: "Partner’s capital account balance at dissolution shows:",
  options: ["final amount payable", "profit only", "expenses", "sales"],
  answer: "final amount payable"
},
{
  question: "If liabilities exceed assets during dissolution:",
  options: ["partners bear loss", "profit occurs", "no effect", "assets increase"],
  answer: "partners bear loss"
},
{
  question: "Correct partnership accounting ensures:",
  options: ["fair distribution", "profit increase", "cost reduction", "sales increase"],
  answer: "fair distribution"
},
{
  question: "Partnership agreement helps to:",
  options: ["avoid disputes", "increase cost", "reduce profit", "ignore rules"],
  answer: "avoid disputes"
},

{
  question: "A company is a:",
  options: ["separate legal entity", "partnership", "sole trader", "government"],
  answer: "separate legal entity"
},
{
  question: "Share capital represents:",
  options: ["owners’ investment", "loan", "expense", "liability"],
  answer: "owners’ investment"
},
{
  question: "Ordinary shares carry:",
  options: ["voting rights", "fixed dividend only", "no rights", "interest"],
  answer: "voting rights"
},
{
  question: "Preference shares receive:",
  options: ["fixed dividend", "variable dividend", "no dividend", "interest"],
  answer: "fixed dividend"
},
{
  question: "Dividend is:",
  options: ["distribution of profit", "expense", "asset", "liability"],
  answer: "distribution of profit"
},
{
  question: "If profit GH¢50,000 and dividend 20%, dividend amount is:",
  options: ["GH¢10,000", "GH¢20,000", "GH¢50,000", "GH¢5,000"],
  answer: "GH¢10,000"
},
{
  question: "Retained earnings are:",
  options: ["profit kept in business", "expense", "liability", "asset"],
  answer: "profit kept in business"
},
{
  question: "Authorized share capital is:",
  options: ["maximum capital allowed", "issued capital", "paid capital", "loan"],
  answer: "maximum capital allowed"
},
{
  question: "Issued share capital is:",
  options: ["shares offered to public", "maximum capital", "loan", "profit"],
  answer: "shares offered to public"
},
{
  question: "Paid-up capital is:",
  options: ["amount actually paid", "maximum capital", "loan", "profit"],
  answer: "amount actually paid"
},
{
  question: "If a company issues 10,000 shares at GH¢2 each, total capital:",
  options: ["GH¢20,000", "GH¢10,000", "GH¢5,000", "GH¢2,000"],
  answer: "GH¢20,000"
},
{
  question: "If 8,000 shares are paid out of 10,000 issued at GH¢2, paid-up capital:",
  options: ["GH¢16,000", "GH¢20,000", "GH¢10,000", "GH¢8,000"],
  answer: "GH¢16,000"
},
{
  question: "Dividend per share =",
  options: ["total dividend / number of shares", "shares × dividend", "profit − cost", "capital − liabilities"],
  answer: "total dividend / number of shares"
},
{
  question: "If dividend GH¢12,000 and shares 6,000, dividend per share:",
  options: ["GH¢2", "GH¢3", "GH¢1", "GH¢4"],
  answer: "GH¢2"
},
{
  question: "Bonus shares are:",
  options: ["free shares to shareholders", "paid shares", "loan", "expense"],
  answer: "free shares to shareholders"
},
{
  question: "Rights issue means:",
  options: ["existing shareholders can buy shares", "free shares", "loan", "expense"],
  answer: "existing shareholders can buy shares"
},
{
  question: "Debentures are:",
  options: ["long-term loans", "shares", "expenses", "assets"],
  answer: "long-term loans"
},
{
  question: "Interest on debentures is:",
  options: ["expense", "income", "asset", "capital"],
  answer: "expense"
},
{
  question: "Final accounts of company include:",
  options: ["income statement and balance sheet", "cash book only", "ledger", "journal"],
  answer: "income statement and balance sheet"
},
{
  question: "Net profit increases:",
  options: ["retained earnings", "expenses", "liabilities", "drawings"],
  answer: "retained earnings"
},
{
  question: "If revenue GH¢100,000 and expenses GH¢70,000, net profit:",
  options: ["GH¢30,000", "GH¢70,000", "GH¢100,000", "GH¢20,000"],
  answer: "GH¢30,000"
},
{
  question: "Cash flow statement shows:",
  options: ["cash inflows and outflows", "profit", "assets", "liabilities"],
  answer: "cash inflows and outflows"
},
{
  question: "Operating activities include:",
  options: ["day-to-day transactions", "purchase of assets", "loans", "shares"],
  answer: "day-to-day transactions"
},
{
  question: "Investing activities include:",
  options: ["purchase of fixed assets", "sales", "expenses", "wages"],
  answer: "purchase of fixed assets"
},
{
  question: "Financing activities include:",
  options: ["issue of shares", "sales", "expenses", "purchases"],
  answer: "issue of shares"
},
{
  question: "If opening cash GH¢5,000 and inflow GH¢10,000, outflow GH¢8,000, closing cash:",
  options: ["GH¢7,000", "GH¢5,000", "GH¢10,000", "GH¢8,000"],
  answer: "GH¢7,000"
},
{
  question: "Profit does not equal cash because:",
  options: ["non-cash items exist", "cash equals profit", "no expenses", "no income"],
  answer: "non-cash items exist"
},
{
  question: "Depreciation affects profit but not cash:",
  options: ["true", "false", "sometimes", "unknown"],
  answer: "true"
},
{
  question: "Company accounts ensure:",
  options: ["accountability to shareholders", "profit only", "cost reduction", "tax avoidance"],
  answer: "accountability to shareholders"
},
{
  question: "Accurate company accounting helps in:",
  options: ["investment decisions", "reducing output", "increasing cost", "ignoring profit"],
  answer: "investment decisions"
},

{
  question: "Opening stock GH¢6,000, purchases GH¢20,000, closing stock GH¢5,000. Cost of goods sold is:",
  options: ["GH¢21,000", "GH¢20,000", "GH¢15,000", "GH¢25,000"],
  answer: "GH¢21,000"
},
{
  question: "Sales GH¢35,000, cost of goods sold GH¢21,000. Gross profit is:",
  options: ["GH¢14,000", "GH¢21,000", "GH¢35,000", "GH¢10,000"],
  answer: "GH¢14,000"
},
{
  question: "Gross profit GH¢14,000, expenses GH¢9,000. Net profit:",
  options: ["GH¢5,000", "GH¢9,000", "GH¢14,000", "GH¢23,000"],
  answer: "GH¢5,000"
},
{
  question: "Debtors GH¢12,000, provision 5%. Net debtors:",
  options: ["GH¢11,400", "GH¢12,000", "GH¢600", "GH¢10,000"],
  answer: "GH¢11,400"
},
{
  question: "Opening debtors GH¢8,000, credit sales GH¢25,000, cash received GH¢20,000. Closing debtors:",
  options: ["GH¢13,000", "GH¢8,000", "GH¢5,000", "GH¢20,000"],
  answer: "GH¢13,000"
},
{
  question: "Opening creditors GH¢6,000, purchases GH¢18,000, payments GH¢15,000. Closing creditors:",
  options: ["GH¢9,000", "GH¢6,000", "GH¢3,000", "GH¢15,000"],
  answer: "GH¢9,000"
},
{
  question: "Machine GH¢10,000 depreciated at 10% reducing balance. First year depreciation:",
  options: ["GH¢1,000", "GH¢900", "GH¢2,000", "GH¢800"],
  answer: "GH¢1,000"
},
{
  question: "Machine GH¢10,000 at 10% reducing balance. Second year depreciation:",
  options: ["GH¢900", "GH¢1,000", "GH¢800", "GH¢950"],
  answer: "GH¢900"
},
{
  question: "Rent paid GH¢4,000, prepaid GH¢1,000. Expense:",
  options: ["GH¢3,000", "GH¢4,000", "GH¢5,000", "GH¢1,000"],
  answer: "GH¢3,000"
},
{
  question: "Wages GH¢5,000, accrued GH¢500. Total expense:",
  options: ["GH¢5,500", "GH¢5,000", "GH¢4,500", "GH¢500"],
  answer: "GH¢5,500"
},
{
  question: "Debtors GH¢10,000, bad debts GH¢500, provision 5%. New provision:",
  options: ["GH¢475", "GH¢500", "GH¢450", "GH¢400"],
  answer: "GH¢475"
},
{
  question: "Opening capital GH¢30,000, closing GH¢45,000, drawings GH¢5,000. Profit:",
  options: ["GH¢20,000", "GH¢15,000", "GH¢10,000", "GH¢5,000"],
  answer: "GH¢20,000"
},
{
  question: "Opening capital GH¢40,000, closing GH¢35,000, drawings GH¢10,000. Result:",
  options: ["GH¢15,000 loss", "GH¢5,000 loss", "GH¢5,000 profit", "GH¢10,000 loss"],
  answer: "GH¢15,000 loss"
},
{
  question: "Prime cost GH¢20,000, overhead GH¢8,000. Production cost:",
  options: ["GH¢28,000", "GH¢20,000", "GH¢8,000", "GH¢30,000"],
  answer: "GH¢28,000"
},
{
  question: "Production cost GH¢28,000, opening WIP GH¢2,000, closing WIP GH¢3,000. Cost of production:",
  options: ["GH¢27,000", "GH¢28,000", "GH¢29,000", "GH¢30,000"],
  answer: "GH¢27,000"
},
{
  question: "Subscriptions received GH¢6,000, outstanding GH¢1,000, advance GH¢500. Income:",
  options: ["GH¢6,500", "GH¢6,000", "GH¢5,500", "GH¢7,000"],
  answer: "GH¢6,500"
},
{
  question: "Opening cash GH¢3,000, receipts GH¢12,000, payments GH¢9,000. Closing cash:",
  options: ["GH¢6,000", "GH¢3,000", "GH¢12,000", "GH¢9,000"],
  answer: "GH¢6,000"
},
{
  question: "If output VAT GH¢8,000 and input VAT GH¢5,000, VAT payable:",
  options: ["GH¢3,000", "GH¢8,000", "GH¢5,000", "GH¢13,000"],
  answer: "GH¢3,000"
},
{
  question: "If sales GH¢40,000 and VAT 15%, VAT amount:",
  options: ["GH¢6,000", "GH¢4,000", "GH¢5,000", "GH¢8,000"],
  answer: "GH¢6,000"
},
{
  question: "A and B share profit 3:2. Profit GH¢10,000. A gets:",
  options: ["GH¢6,000", "GH¢4,000", "GH¢5,000", "GH¢3,000"],
  answer: "GH¢6,000"
},
{
  question: "Interest on capital GH¢20,000 at 10%:",
  options: ["GH¢2,000", "GH¢1,000", "GH¢500", "GH¢3,000"],
  answer: "GH¢2,000"
},
{
  question: "Dividend GH¢15,000, shares 5,000. Dividend per share:",
  options: ["GH¢3", "GH¢2", "GH¢5", "GH¢4"],
  answer: "GH¢3"
},
{
  question: "Opening stock GH¢5,000, purchases GH¢15,000, closing GH¢6,000. COGS:",
  options: ["GH¢14,000", "GH¢15,000", "GH¢16,000", "GH¢20,000"],
  answer: "GH¢14,000"
},
{
  question: "If liabilities increase without asset increase, capital:",
  options: ["decreases", "increases", "same", "zero"],
  answer: "decreases"
},
{
  question: "If expenses are omitted, profit is:",
  options: ["overstated", "understated", "correct", "zero"],
  answer: "overstated"
},
{
  question: "If revenue is omitted, profit is:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "Cash discount allowed is:",
  options: ["expense", "income", "asset", "liability"],
  answer: "expense"
},
{
  question: "Cash discount received is:",
  options: ["income", "expense", "asset", "liability"],
  answer: "income"
},
{
  question: "Accrued income is shown as:",
  options: ["asset", "liability", "expense", "income"],
  answer: "asset"
},
{
  question: "Prepaid expense is shown as:",
  options: ["asset", "liability", "income", "expense"],
  answer: "asset"
},

{
  question: "The going concern concept assumes that the business will:",
  options: ["continue operating indefinitely", "close soon", "sell assets immediately", "reduce operations"],
  answer: "continue operating indefinitely"
},
{
  question: "The matching concept requires:",
  options: ["expenses matched with revenue", "cash matched with profit", "assets matched with liabilities", "sales matched with cash"],
  answer: "expenses matched with revenue"
},
{
  question: "Prudence concept means:",
  options: ["do not overstate profit", "increase profit", "ignore expenses", "record gains early"],
  answer: "do not overstate profit"
},
{
  question: "Consistency concept ensures:",
  options: ["same methods used over time", "methods change yearly", "no accounting rules", "random decisions"],
  answer: "same methods used over time"
},
{
  question: "Accrual concept records:",
  options: ["income and expenses when incurred", "cash only", "profit only", "assets only"],
  answer: "income and expenses when incurred"
},
{
  question: "Suspense account is used to:",
  options: ["temporarily hold errors", "record sales", "record purchases", "calculate profit"],
  answer: "temporarily hold errors"
},
{
  question: "If trial balance does not balance, difference goes to:",
  options: ["suspense account", "cash book", "ledger", "P&L"],
  answer: "suspense account"
},
{
  question: "Error of omission means:",
  options: ["transaction not recorded", "wrong amount", "wrong account", "double entry"],
  answer: "transaction not recorded"
},
{
  question: "Error of commission means:",
  options: ["wrong amount or account", "no entry", "duplicate entry", "correct entry"],
  answer: "wrong amount or account"
},
{
  question: "Error of principle occurs when:",
  options: ["wrong type of account used", "amount wrong", "entry omitted", "balanced wrongly"],
  answer: "wrong type of account used"
},
{
  question: "If purchase of GH¢1,000 is debited to sales account, error type:",
  options: ["error of principle", "error of omission", "error of commission", "no error"],
  answer: "error of principle"
},
{
  question: "Suspense account balance is cleared when:",
  options: ["errors corrected", "profit calculated", "cash received", "sales made"],
  answer: "errors corrected"
},
{
  question: "Departmental accounts are used to:",
  options: ["measure performance of each department", "calculate VAT", "record cash", "prepare ledger"],
  answer: "measure performance of each department"
},
{
  question: "Branch account is used to:",
  options: ["record branch transactions", "record head office only", "calculate profit only", "record VAT"],
  answer: "record branch transactions"
},
{
  question: "Goods sent to branch are recorded as:",
  options: ["transfer", "sales", "purchase", "expense"],
  answer: "transfer"
},
{
  question: "Public sector accounting focuses on:",
  options: ["government activities", "private business", "clubs", "partnerships"],
  answer: "government activities"
},
{
  question: "Public revenue includes:",
  options: ["taxes", "sales", "expenses", "profit"],
  answer: "taxes"
},
{
  question: "Capital expenditure is:",
  options: ["long-term benefit", "day-to-day expense", "income", "liability"],
  answer: "long-term benefit"
},
{
  question: "Recurrent expenditure is:",
  options: ["regular expenses", "capital asset", "income", "loan"],
  answer: "regular expenses"
},
{
  question: "Which is capital expenditure?",
  options: ["purchase of building", "payment of wages", "rent", "electricity"],
  answer: "purchase of building"
},
{
  question: "Which is recurrent expenditure?",
  options: ["payment of salaries", "purchase of land", "machinery", "vehicle"],
  answer: "payment of salaries"
},
{
  question: "Current ratio =",
  options: ["current assets / current liabilities", "profit / sales", "assets − liabilities", "sales / cost"],
  answer: "current assets / current liabilities"
},
{
  question: "If current assets GH¢20,000 and liabilities GH¢10,000, ratio:",
  options: ["2:1", "1:1", "3:1", "0.5:1"],
  answer: "2:1"
},
{
  question: "Quick ratio excludes:",
  options: ["stock", "cash", "debtors", "bank"],
  answer: "stock"
},
{
  question: "Profit margin =",
  options: ["profit / sales", "sales / profit", "cost / sales", "assets / liabilities"],
  answer: "profit / sales"
},
{
  question: "If profit GH¢10,000 and sales GH¢50,000, margin:",
  options: ["20%", "10%", "50%", "25%"],
  answer: "20%"
},
{
  question: "High current ratio indicates:",
  options: ["good liquidity", "low profit", "high cost", "loss"],
  answer: "good liquidity"
},
{
  question: "Low current ratio indicates:",
  options: ["liquidity problem", "high profit", "low cost", "strong position"],
  answer: "liquidity problem"
},
{
  question: "Gross profit margin measures:",
  options: ["efficiency in production", "cash flow", "assets", "liabilities"],
  answer: "efficiency in production"
},
{
  question: "Net profit margin measures:",
  options: ["overall profitability", "sales only", "assets only", "liabilities"],
  answer: "overall profitability"
},

{
  question: "A purchase of GH¢2,000 was recorded as GH¢200. The error will cause profit to be:",
  options: ["overstated", "understated", "correct", "zero"],
  answer: "overstated"
},
{
  question: "Sales of GH¢5,000 omitted from books will cause profit to be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "A payment of GH¢1,000 posted twice will cause profit to be:",
  options: ["understated", "overstated", "correct", "zero"],
  answer: "understated"
},
{
  question: "Suspense account balance GH¢500 debit means:",
  options: ["credits exceed debits by GH¢500", "debits exceed credits", "no error", "profit exists"],
  answer: "credits exceed debits by GH¢500"
},
{
  question: "Correction of an error clears suspense account by:",
  options: ["adjusting entries", "adding profit", "removing assets", "increasing capital"],
  answer: "adjusting entries"
},
{
  question: "Department A profit GH¢20,000, Department B GH¢10,000. Total:",
  options: ["GH¢30,000", "GH¢20,000", "GH¢10,000", "GH¢15,000"],
  answer: "GH¢30,000"
},
{
  question: "Allocation of rent between departments is based on:",
  options: ["floor area", "sales only", "profit only", "cash"],
  answer: "floor area"
},
{
  question: "If total rent GH¢12,000 and area ratio 2:1, larger department gets:",
  options: ["GH¢8,000", "GH¢4,000", "GH¢12,000", "GH¢6,000"],
  answer: "GH¢8,000"
},
{
  question: "Branch debtors GH¢10,000, cash received GH¢7,000, credit sales GH¢12,000. Closing debtors:",
  options: ["GH¢15,000", "GH¢10,000", "GH¢5,000", "GH¢12,000"],
  answer: "GH¢15,000"
},
{
  question: "Goods sent to branch GH¢8,000 and returned GH¢1,000. Net goods:",
  options: ["GH¢7,000", "GH¢8,000", "GH¢1,000", "GH¢9,000"],
  answer: "GH¢7,000"
},
{
  question: "Branch profit is determined by:",
  options: ["branch income − expenses", "cash only", "assets", "liabilities"],
  answer: "branch income − expenses"
},
{
  question: "Public sector focuses on:",
  options: ["accountability", "profit", "sales", "cost"],
  answer: "accountability"
},
{
  question: "Major source of government revenue is:",
  options: ["taxation", "sales", "profit", "donations"],
  answer: "taxation"
},
{
  question: "Capital expenditure leads to:",
  options: ["asset creation", "expense only", "loss", "liability"],
  answer: "asset creation"
},
{
  question: "Recurrent expenditure includes:",
  options: ["wages", "buildings", "machinery", "vehicles"],
  answer: "wages"
},
{
  question: "Cash flow from operations excludes:",
  options: ["purchase of machinery", "sales receipts", "wages", "expenses"],
  answer: "purchase of machinery"
},
{
  question: "Cash flow from investing includes:",
  options: ["purchase of equipment", "sales", "expenses", "wages"],
  answer: "purchase of equipment"
},
{
  question: "Cash flow from financing includes:",
  options: ["issue of shares", "sales", "expenses", "purchases"],
  answer: "issue of shares"
},
{
  question: "Opening cash GH¢4,000, inflow GH¢10,000, outflow GH¢6,000. Closing cash:",
  options: ["GH¢8,000", "GH¢4,000", "GH¢10,000", "GH¢6,000"],
  answer: "GH¢8,000"
},
{
  question: "If profit GH¢15,000 and depreciation GH¢3,000, cash from operations increases by:",
  options: ["GH¢3,000", "GH¢15,000", "GH¢18,000", "GH¢12,000"],
  answer: "GH¢3,000"
},
{
  question: "Increase in debtors reduces cash because:",
  options: ["less cash collected", "more cash", "profit increases", "expenses reduce"],
  answer: "less cash collected"
},
{
  question: "Increase in creditors increases cash because:",
  options: ["less cash paid", "more expenses", "profit reduces", "assets increase"],
  answer: "less cash paid"
},
{
  question: "Current ratio 1:1 indicates:",
  options: ["moderate liquidity", "high liquidity", "low liquidity", "no liquidity"],
  answer: "moderate liquidity"
},
{
  question: "Quick ratio 0.5:1 indicates:",
  options: ["poor liquidity", "good liquidity", "high profit", "low cost"],
  answer: "poor liquidity"
},
{
  question: "High gross profit margin suggests:",
  options: ["efficient production", "high cost", "loss", "low sales"],
  answer: "efficient production"
},
{
  question: "Low net profit margin suggests:",
  options: ["high expenses", "low cost", "high profit", "strong business"],
  answer: "high expenses"
},
{
  question: "If assets GH¢100,000 and liabilities GH¢60,000, capital:",
  options: ["GH¢40,000", "GH¢100,000", "GH¢60,000", "GH¢160,000"],
  answer: "GH¢40,000"
},
{
  question: "If revenue GH¢80,000 and expenses GH¢50,000, profit:",
  options: ["GH¢30,000", "GH¢50,000", "GH¢80,000", "GH¢20,000"],
  answer: "GH¢30,000"
},
{
  question: "If trial balance balances, it means:",
  options: ["arithmetical accuracy only", "no errors", "profit correct", "all correct"],
  answer: "arithmetical accuracy only"
},
{
  question: "Errors not affecting trial balance include:",
  options: ["errors of principle", "arithmetical errors", "casting errors", "balancing errors"],
  answer: "errors of principle"
}
];
export default accountingQuestions;